import Accordion from "./Accordion";
import Tabs from "./Tabs";

/**
 * Комплексный блок. На большом экране показываются табы, на мобильном разрешении - аккордеон
 */
export default function tabAccordion(
    accrodionSelector: string = '.js-tab-accordion_accordion',
    tabsSelector: string = '.js-tab-accordion_tab'
) {
    new Accordion(accrodionSelector).init();

    let tabs = new Tabs(tabsSelector);
    tabs.setClassToken('hidden', 'tab-accordion_hidden');
    tabs.init();
}
